export enum TicketCategorie {
  Bug           = 0,
  Fonctionnalite = 1,
  Amelioration  = 2,
  Question      = 3,
  Autre         = 4,
}

export enum TicketStatut {
  Ouvert  = 0,
  EnCours = 1,
  Resolu  = 2,
  Ferme   = 3,
}

export interface SupportTicketAttachmentDto {
  id:          number;
  nomOriginal: string;
  mimeType:    string;
  taille:      number;
  creeLe:      string;
}

export interface SupportTicketDto {
  id:          number;
  idCitoyen:   number;
  sujet:       string | null;
  message:     string | null;
  categorie:   TicketCategorie;
  statut:      TicketStatut;
  creeLe:      string;
  modifieLe:   string;
  attachments: SupportTicketAttachmentDto[] | null;
}
